import api from "./api";

const URL = "/seasons";

export const getSeasons = async () => {
  const { data } = await api.get(URL);
  return data;
};
